export default __webpack_public_path__ + "static/media/document.791c15f6.svg";